import { createSlice } from "@reduxjs/toolkit";

export const mobileMenuState = {
  isOpen: false,
};

const MobileMenuSlice = createSlice({
  name: "mobileMenu",
  initialState: mobileMenuState,
  reducers: {
    setMenu(state, action) {
      state.isOpen = action.payload;
    },
  },
});

export const MobileMenuActions = {
  ...MobileMenuSlice.actions,
};

export default MobileMenuSlice.reducer;
